

const Colors = {
    DarkBlue:"#0F5868",
    LightBlue:"#48A3BD",
    Blue:"#0D7C97",
    White:"#F8F5F1"
};

export {Colors};